import React, { useEffect, useState } from "react";
import { getCallScriptTemplate } from "services/CallScript";
import CallScript, { callScriptState } from "./CallScript";
import "./CallScript.less";

export default function CallScriptConatiner({ serviceID }) {
  const [templates, setTemplates] = useState([]);
  const [poppedScriptIndex, setPoppedScriptIndex] = useState(null);

  useEffect(() => {
    if (!serviceID) return;
    getCallScriptTemplate(serviceID).then((res) => {
      setTemplates(res.data);
      setPoppedScriptIndex(null);
    });
  }, [serviceID]);

  return (
    <div className="call-script-container">
      {templates.map((props, i) => (
        <CallScript
          {...props}
          isPopped={poppedScriptIndex == i}
          setPopped={() => setPoppedScriptIndex(i)}
          onClose={() => setPoppedScriptIndex(null)}
        />
      ))}
    </div>
  );
}
